// frontend/packages/shared/services/src/userService.js

import { api, authApi } from './apiService.js';

const encodeId = (value, name) => {
  if (value === undefined || value === null) {
    throw new Error(`${name} is required`);
  }
  const trimmed = String(value).trim();
  if (!trimmed) {
    throw new Error(`${name} is required`);
  }
  return encodeURIComponent(trimmed);
};

export async function setUserProfilePicture(userId, payload = {}, options = {}) {
  const encodedUserId = encodeId(userId, 'userId');
  const { profilePictureAssetId } = payload || {};
  if (!profilePictureAssetId) {
    throw new Error('profilePictureAssetId is required');
  }

  const { data } = await api.put(
    `/users/${encodedUserId}/profile-picture`,
    { profilePictureAssetId },
    options,
  );
  return data;
}

export async function updateMyProfile(payload) {
  const { data } = await authApi.patch("/api/auth/me", payload);
  return data?.user || data;
}
